import { filter, first, orderBy } from 'lodash';

/**
 * Return first not cancelled subscription.
 *
 * @param  {Array} subscriptions User subscriptions.
 * @returns {object}             Single subscription.
 */
export default (subscriptions) => {
    return first(
        orderBy(
            filter(subscriptions, (subscription) => {
                return 'canceled' !== subscription.stripe_status;
            }),
            ['created_at'],
            ['desc']
        )
    );
};
